import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[smsAggregatorImageWidth]',
  standalone: true
})
export class SmsAggregatorImageWidth implements OnInit {

  @Input("smsAggregatorImageWidth") smsAggregator: string;

  constructor(private element: ElementRef) { }

  ngOnInit(): void {
    this.element.nativeElement.width = this.getSmsAggregatorImgWidth();
  }

  getSmsAggregatorImgWidth(): string {

    let imgWidth = "";
    switch (this.smsAggregator) {
      case "MCI":
        imgWidth = "30";
        break;
      case "Irancell":
        imgWidth = "30";
        break;
      case "Rightel":
        imgWidth = "60";
        break;
      default:
        break;
    }
    return imgWidth;
  }

}
